"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.counter = void 0;
const fonts_1 = require("../basic/fonts");
const shadows_1 = require("../basic/shadows");
exports.counter = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '35px',
    height: '35px',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '50%',
    fontSize: fonts_1.fontSizes[2],
    boxShadow: shadows_1.shadows.large,
    position: 'absolute',
};
//# sourceMappingURL=counter.js.map